import React, { ForwardRefRenderFunction, forwardRef } from "react";

//#region components
import GenericForm from "components/common/forms/genericForm";
//#endregion

//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { ConvertToGenericDocumentFormProps } from "models/propTypes/receiptPropTypes";
//#endregion
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";



const ConvertToGenericDocumentForm: ForwardRefRenderFunction<FormHandles, ConvertToGenericDocumentFormProps> = (props, ref) => {
  return (
    <GenericForm<DocumentFormTypes.SendBack>
      formRef={ref}
      {...props}
      fields={{
        message: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
    />
  );
};

export default forwardRef(ConvertToGenericDocumentForm);